import React from "react";

function InputIntegerField({
                               input,
                               className,
                               placeholder,
                               autoComplete,
                               inputProps,
                               disabled,
                               meta: {error, submitError}
                           }) {
    const handleInputChange = (event) => {
        let newValue = event.target.value.replace(/[^\d]/g, "");
        newValue = newValue.replace(/^0+/, '');
        if (event.nativeEvent.inputType === 'insertFromPaste') {
            newValue = parseInt(newValue, 10);
            if (isNaN(newValue)) newValue = '';
        }
        input.onChange(newValue);
    };

    const handleArrowKey = (event) => {
        const step = 1;
        let newValue = parseInt(input.value, 10) || 0;
        if (event.key === "ArrowUp") newValue += step;
        else if (event.key === "ArrowDown" && newValue > 0) newValue -= step;
        input.onChange(newValue);
    };

    const hasError = !!error || !!submitError;
    const inputClassName = hasError ? `${className} control-error` : className;

    return (
        <input
            {...input}
            {...inputProps}
            className={inputClassName}
            placeholder={placeholder}
            autoComplete={autoComplete}
            disabled={disabled}
            onChange={handleInputChange}
            onKeyDown={handleArrowKey}
        />
    );
}

export default InputIntegerField;
